import { Constants } from "lib-core";

const parseJwtSimple = (token: string) => {
  try {
    return JSON.parse(atob(token?.split(".")[1] || ""));
  } catch (e) {
    return null;
  }
};

const getUserRoles = (): string[] => {
  const parsedToken = parseJwtSimple(
    localStorage.getItem(Constants.accessToken) || ""
  );

  return parsedToken?.roles || [];
};

export const isCommunityManagerRole = (): boolean => {
  const roles = getUserRoles();
  return roles.includes("Community.Managers");
};
